export const DEBOUNCE_INTERVAL = 1000
